// DAY-DIRECTSTAFF-2026-10-24 §4: is an email field a real address? something@something.tld, no spaces -- anything else (blank, a
// placeholder like "n/a" or "-", half an address) is "no email on file". The same rule the agents' contact matching uses since 10-24.
const RE = /^[^@\s]+@[^@\s]+\.[^@\s.]{2,}$/;
/** the address trimmed and lower-cased, or '' when it is not usable */
export function usableEmail(v) {
  const e = String(v === null || v === undefined ? '' : v).trim().toLowerCase();
  return RE.test(e) ? e : '';
}
/** true when the field holds something that is not an address (a placeholder) -- blank is just "no email" */
export const isPlaceholderEmail = (v) => !!String(v || '').trim() && !usableEmail(v);
